export default __webpack_public_path__ + "static/media/instagram.74c09299.svg";